import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, fill, outline, gradient }) {
  const randomGradientId1 = `_${useRandomId()}`
  const randomGradientId2 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M13.4001 6.90564C11.9401 2.69564 8.6801 0.475639 4.7701 1.10564C0.970098 1.71564 -0.289898 6.76564 2.5401 12.4756C5.9501 19.3356 12.8201 22.8056 12.8201 22.8056C12.8201 22.8056 16.2801 15.2156 13.4001 6.90564Z"
        fill={fill}
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M4.50058 11.8256C4.50058 11.8256 2.77058 6.5456 5.17058 5.1356C7.55058 3.7356 11.6006 7.0856 11.4906 16.4156"
        fill={`url(#${randomGradientId1})`}
      />
      <path
        d="M4.50034 11.8256C4.12034 10.9756 3.88034 10.0756 3.70034 9.1556C3.55034 8.2356 3.50033 7.2556 3.80033 6.2756C4.06033 5.2756 5.09033 4.3956 6.21033 4.3756C7.34033 4.3556 8.30033 4.9656 8.99033 5.6656C10.3603 7.1456 11.0103 9.0156 11.3403 10.8556C11.6803 12.7056 11.6803 14.5856 11.4803 16.4156C11.2903 14.5756 11.0303 12.7656 10.5803 11.0256C10.1203 9.3056 9.44033 7.5956 8.27033 6.3656C7.70033 5.7556 6.96033 5.3256 6.23033 5.3156C5.49033 5.3056 4.82033 5.7856 4.52033 6.5356C4.22033 7.2956 4.14034 8.2056 4.17034 9.0956C4.20034 10.0056 4.34034 10.9156 4.50034 11.8256Z"
        fill={outline}
      />
      <path
        d="M68.6403 6.90564C70.1003 2.69564 73.3603 0.475639 77.2703 1.10564C81.0703 1.71564 82.3303 6.76564 79.5003 12.4756C76.0903 19.3356 69.2203 22.8056 69.2203 22.8056C69.2203 22.8056 65.7703 15.2156 68.6403 6.90564Z"
        fill={fill}
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M77.5503 11.8257C77.5503 11.8257 79.2803 6.54572 76.8803 5.13572C74.5003 3.73572 70.4503 7.08572 70.5603 16.4157"
        fill={`url(#${randomGradientId2})`}
      />
      <path
        d="M77.5503 11.8257C77.7103 10.9157 77.8503 10.0057 77.8603 9.10569C77.9003 8.20569 77.8203 7.29569 77.5103 6.54569C77.2103 5.79569 76.5403 5.31569 75.8003 5.32569C75.0703 5.33569 74.3303 5.76569 73.7603 6.37569C72.6003 7.60569 71.9103 9.31569 71.4503 11.0357C71.0003 12.7757 70.7403 14.5857 70.5503 16.4257C70.3503 14.5957 70.3403 12.7157 70.6903 10.8657C71.0203 9.02569 71.6803 7.15569 73.0403 5.67569C73.7303 4.97569 74.6903 4.35569 75.8203 4.38569C76.9403 4.40569 77.9703 5.28569 78.2303 6.28569C78.5403 7.26569 78.4903 8.24569 78.3303 9.16569C78.1703 10.0757 77.9303 10.9757 77.5503 11.8257Z"
        fill={outline}
      />
      <defs>
        <radialGradient
          id={randomGradientId1}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(10.5687 3.2046) scale(11.8741)"
        >
          <stop stopColor={gradient[0]} />
          <stop offset="1" stopColor={gradient[1]} />
        </radialGradient>
        <radialGradient
          id={randomGradientId2}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(71.4794 3.20472) rotate(180) scale(11.8741)"
        >
          <stop stopColor={gradient[0]} />
          <stop offset="1" stopColor={gradient[1]} />
        </radialGradient>
      </defs>
    </g>
  )
}
